var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"commonPage"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"img_box"},[_c('img',{attrs:{"src":'/img/home/' + _vm.imgName + '?timestamp=' + new Date().getTime(),"alt":""}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }